import * as React from "react";
import * as PropTypes from "prop-types";
import * as ReactModal from "react-modal";

interface IModalProps {
    height?: string;
    width?: string;
    maxWidth?: string;
    onRequestClose?: Function;
    isOpen: boolean;
    label?: string;
}

export class Spinner extends React.PureComponent<IModalProps, any> {
    render() {
        const modalStyle = {
            overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                zIndex: 3
            },
            content: {
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
                height: "100px",
                width: "200px",
                maxWidth: "200px",
                background: "none",
                padding: "0px",
                border: "none",
                borderRadius: "0px"
            }
        };

        const label = this.props.label || "Loading";

        return (
            <ReactModal
                isOpen={this.props.isOpen}
                style={modalStyle}
                contentLabel="spinner"
                onRequestClose={this.props.onRequestClose}
            >
                <div className="text-white">
                    <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                    {label}
                </div>
            </ReactModal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Spinner.tsx